import { useEffect } from "react";
import { useMst } from "../stores/main";
import {
  getUndoRedoShortcutAction,
  isKeyboardShortcutSuppressedTarget,
} from "./keyboardShortcutGuards";

/**
 * Hook that sets up keyboard shortcuts for undo/redo:
 * - Cmd+Z (Mac) / Ctrl+Z (Windows) for undo
 * - Cmd+Shift+Z (Mac) / Ctrl+Shift+Z (Windows) for redo
 */
export function useUndoRedoShortcuts() {
  const { undoStore } = useMst();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (isKeyboardShortcutSuppressedTarget(e.target)) {
        return;
      }

      const shortcutAction = getUndoRedoShortcutAction(e);
      if (shortcutAction) {
        e.preventDefault();

        if (shortcutAction === "redo") {
          undoStore.redo();
        } else {
          undoStore.undo();
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [undoStore]);
}
